<template>
    <div class="mb-4">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <label v-if="segundaOpcionCreada" class="d-flex justify-content-center mt-4">PTI opción {{ index + 1 }}</label>
        <b-row class="mt-3 text-center mb-3">
            <b-col>
                <p class="headers text-left">Tratamiento</p>
            </b-col>
            <b-col cols="3">
                <p class="headers">Cantidad</p>
            </b-col>
        </b-row>
        <hr style="margin-top: -2%;">
        
        <div v-if="tratamientos.length > 0">
            <loading :active.sync="loadTrt" :can-cancel="false" :is-full-page="false"></loading>
            <div v-for="(item, i) in tratamientos" :key="'tratamiento' + i">
                <b-row class="d-flex justify-content-center align-items-center" style="font-size: .85em;">
                    <b-col class="text-left">
                        <p>
                          <em v-if="item.idKit !== null" class="kit_svg"/>
                          {{ item.descripcion }}
                          <b-icon v-if="item.idKit !== null" icon="chevron-down" font-scale="1.1" v-b-toggle="item.idKit+'t'+i+'ind'"></b-icon>
                        </p>
                    </b-col>
                    <b-col cols="3" align="center">
                        <p>{{item.cantidad}}</p>
                        <p v-if="item.idKit !== null">1</p>
                    </b-col>
                </b-row>
                <b-collapse :id="item.idKit+'t'+i+'ind'" accordion="my-accordion"
                    role="tabpanel" style="font-size: .85em;">
                    <b-row>
                        <b-col cols="3" class="pr-0" v-if="imagenKit != null && !segundaOpcionCreada">
                            <img :src="'data:image/png;base64,' + imagenKit " alt="img" style="height: 240px"/>
                        </b-col>
                        <b-col class="p-0">
                            <b-row class="ml-0 mr-0" style="color: gray;" v-for="(trt,indexTratamiento) in item.tratamientosKits" :key="indexTratamiento">
                                <b-col cols="1"><em class="tratamiento_outline_inactivo" style="width: 1.4em;"></em></b-col>
                                <b-col align="left" :class="imagenKit!=null && !segundaOpcionCreada ? 'p-0' : 'p-0'"><span>{{ trt.descripcion }}</span></b-col>
                                <b-col cols="3" class="text-center"><span>{{ trt.cantidad }}</span></b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-collapse>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 15vh;">
                <p>Sin tratamientos agregados</p>
        </div>
        <b-modal
            size="xl"
            v-model="mostrarArgumentarioTx"
            scrollable
            hide-footer
        >
        <template #modal-header>
            <div style="display: flex;width: 100%;">
            <div class="d-flex align-items-center detalle-formulario">
                <em class="info_relleno_azul" style="height: 25px;"></em>
                <label class="detalle-formulario-h1 ml-3"
                    style="font-size: 20px; font-weight: bolder !important; color: var(--color-dentalia) !important;">
                Información de tratamiento
                </label>

            </div>
            <b-button class="button-dentalia-svg-4 mr-2" variant="primary"
                        @click="mostrarArgumentarioTx = false">
                <em class="close_x_svg icon-dentalia-svg-0" style="height: 16px; "></em>
            </b-button>
            </div>
        </template>

        <informacionArgumentario v-if="mostrarArgumentarioTx"
                                :idTratamiento="datosArgumentarioTx.idTx"
                                :nombreTratamiento="datosArgumentarioTx.nombreTx"/>
        </b-modal>
    </div>
</template>

<script>
import InformacionArgumentario from "@/version5/componentes/informacionArgumentario.vue";
export default {
    name: "HDTratamientosViewOnly",
    components: {
        InformacionArgumentario
    },
    props: {
        contraerCard: Boolean,
        disable: {
            type: Boolean,
            default: false
        },
        tratamientos: null,
        index: Number,
        indexTarjeta: Number,
        segundaOpcionCreada: Boolean
    },
    data: () => {
        return {
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            old: null,
            newData:null,
            mastrarPrecio: false,
            mostrarArgumentarioTx: false,
            datosArgumentarioTx: [],
            imagenKit: null,
            loadTrt: false,
        }
    },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
        cambiarPaquete(item) {
            this.$emit('cambiarPaquete', this.index, item)
        },
        agregarTratamiento() {
            const item = {idTratamiento: null, cantidad: 1, modificado: true, collapseOpen: false, idKit: null}
            this.tratamientos.push(JSON.parse(JSON.stringify(item)))
            this.$emit('padecimientoModificado')
        },
        eliminarTratamiento(item) {
            this.tratamientos.splice(this.tratamientos.indexOf(item), 1)
            this.$emit('padecimientoModificado')
        },
        limpiar() {
            this.tratamientos.forEach(tratamiento => {
                tratamiento.idTratamiento = null;
                tratamiento.cantidad =  1;
                tratamiento.nombreTratamiento = "";
                tratamiento.precio = null;
            });
        },
        verArgumentario(idTx, nombre){
            this.datosArgumentarioTx.idTx = idTx;
            this.datosArgumentarioTx.nombreTx = nombre;
            this.mostrarArgumentarioTx = true;
        },
        obtenerImagenKit(idKit){
            this.loadTrt = true;
            this.imagenKit = null;
            const parametros = {idKit: idKit}
            this.$http.post(this.$api + "version5/ptipresuntivo/obtener/imagenKit", parametros).then(response=>{
                this.loadTrt = false;
                this.imagenKit = response.data.data.imagenKit;
            })
        }
    }
}
</script>

<style scoped>
label {
    color: rgb(50, 50, 50) !important;
}

.headers{
    color: #7A7A7A;
    font-weight: 500;
    font-size: .9em;
}

</style>
